export default [
  {
    path: 'all-sales-stats',
    redirect: { name: 'TotalSalesStatusReportList' },
    children: [
      // 전체
      {
        path: 'list',
        name: 'TotalSalesStatusReportList',
        meta: { menu: 'total-sales-status-report', keepAlive: true },
        component: () => import('@/pages/reportMng/allSalesStats/TotalSalesStatusReportListView.vue')
      },
    ]
  }
]
